// src/components/LandingPage.js
import React, { useState, useRef, useEffect } from 'react';
import './LandingPage.css';
import AboutUs from "./AboutUs";
import ServicesSection from "./ServicesSection";
import Reviews from "./Reviews";
import ParallaxImage from "./ParallaxImage";
import Contact from './Contact';
import Projekte from './Projekte';
import TraumgartenSection from './traumgarten/TraumgartenSection';
import { GardenPlanProvider } from '../context/GardenPlanContext';


function LandingPage() {


    return (
        <GardenPlanProvider>
            <div className="landing-page">

                <ServicesSection />

                <Projekte />

                <TraumgartenSection />

                <Contact />

                
                <AboutUs />
                <Reviews />

            </div>
        </GardenPlanProvider>
    );
};

// Move export statement here
export default LandingPage;